import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ORDER_LINE } from './fragments';

export const GET_FULFILLMENT_DELTAS = gql`
  ${ORDER_LINE}
  query ${PRODUCT}GetFulfillmentDeltasPerRoute($input: RouteInput!) {
    route(input: $input) {
      id
      name
      isLobby
      stops {
        ... on Delivery {
          id
          sequenceNumber
          deliveryStatusDmp
          reminderMessage
          location {
            id
            businessName
          }
          orders {
            id
            erpRecordUrl
            itemLevelTracking
            fulfillmentStatus
            warehouseNote
            orderLines {
              ...OrderLineFragment
            }
            vendor {
              id
              name
              legalName
            }
          }
        }
      }
    }
  }
`;
